import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLDivElement> {
  connect(): void {
    const identifier = this.element.dataset.identifier
    const tbody = this.element.closest('tbody') ?? null
    if (tbody === null) return

    const rowContentElementsForThisColumn = tbody.querySelectorAll(
      `[data-identifier="${identifier}"]`
    )
    let biggestWidth = 0

    rowContentElementsForThisColumn.forEach(element => {
      if (biggestWidth < element.clientWidth) biggestWidth = element.clientWidth
    })

    this.element.style.width = `${biggestWidth}px`
  }
}
